import React from 'react';

export const HatchingEgg = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5958_4020)">
      <path
        d="M26 19C26 21.6522 24.9464 24.1957 23.0711 26.0711C21.1957 27.9464 18.6522 29 16 29C13.3478 29 10.8043 27.9464 8.92893 26.0711C7.05357 24.1957 6 21.6522 6 19C6 11 12 3 16 3C20 3 26 11 26 19Z"
        stroke="#9075D1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9246 18.7498L19.8246 14.1123L16.2246 12.7123L21.5871 6.7373"
        stroke="#9075D1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5958_4020">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
